import { Admin, Resource, ListGuesser, CustomRoutes, usePermissions } from "react-admin";
import MyLogin from '../loginPage';
import authProvider from './authProvider';
import dataProvider from "./dataProvider";
import polyglotI18nProvider from 'ra-i18n-polyglot';
import chinese from './chinese';
import { Route } from "react-router-dom";
import ChangePwd from "../customLayout/ChangePwd";
// import { AdminCreate, AdminList } from './components/Admin';

import MyLayout from "./customLayout/layout";
import Dashboard from "./components/dashboardPage";
import GroupIcon from '@mui/icons-material/Group';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PaidIcon from '@mui/icons-material/Paid';
import ShieldIcon from '@mui/icons-material/Shield';
import AppsIcon from '@mui/icons-material/Apps';
import CategoryIcon from '@mui/icons-material/Category';
import SortIcon from '@mui/icons-material/Sort';
import FactoryIcon from '@mui/icons-material/Factory';
import PlaceIcon from '@mui/icons-material/Place';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// const dataProvider = jsonServerProvider("https://jsonplaceholder.typicode.com");

import { MemberList, MemberCreate, MemberEdit, MemberShow } from './components/Member';
import { MemberZDconfigList, MemberZDconfigCreate, MemberZDconfigEdit, MemberZDconfigShow } from './components/MemberZDconfig';
import { ZdMemberDiscountList, ZdMemberDiscountCreate, ZdMemberDiscountEdit, ZdMemberDiscountShow } from './components/zdMemberDiscount';
import { PartnerServiceChartList, PartnerServiceChartCreate, PartnerServiceChartEdit, PartnerServiceChartShow } from './components/PartnerServiceChart';
import { MarketPtrotectionList, MarketPtrotectionCreate, MarketPtrotectionEdit, MarketPtrotectionShow } from './components/MarketPtrotection';
import { HospitalShengList, HospitalShengCreate, HospitalShengEdit, HospitalShengShow } from './components/HospitalSheng';
import { HospitalCityList, HospitalCityCreate, HospitalCityEdit, HospitalCityShow } from './components/HospitalCity';
import { ProductList, ProductCreate, ProductEdit, ProductShow } from './components/Product';
import { ProductCompanyList, ProductCompanyCreate, ProductCompanyEdit, ProductCompanyShow } from './components/ProductCompany';
import { ProductCountryList, ProductCountryCreate, ProductCountryEdit, ProductCountryShow } from './components/ProductCountry';
import { ProductCategoryList, ProductCategoryCreate, ProductCategoryEdit, ProductCategoryShow } from './components/ProductCategory';
import { SupplierList, SupplierCreate, SupplierEdit, SupplierShow } from './components/Supplier';
import SortsDashboard from "../customLayout/SortsDashboard";
import SortsDashboard2 from "../customLayout/SortsDashboard_sub";

//设置语言为 中文
const i18nProvider = polyglotI18nProvider(() => chinese, 'zh', { allowMissing: true });

const App = () => {
    return (
        <Admin
            title="后台管理"
            loginPage={MyLogin}
            layout={MyLayout}
            dashboard={Dashboard}
            authProvider={authProvider}
            dataProvider={dataProvider}
            i18nProvider={i18nProvider}
        >
            {(permissions) => {
                // console.log('permissions', permissions)
                let isAdmin = permissions === 'Admin';

                const adminList = isAdmin ? [

                    <Resource options={{ group: '会员', label: '会员列表', icon: <GroupIcon /> }}
                        name="Admin/CMSMember" list={MemberList} show={MemberShow} />,
                    <Resource options={{ group: '会员', label: '总服务商', icon: <BusinessCenterIcon /> }}
                        name="Admin/CMSMemberZDconfig" list={MemberZDconfigList}
                        //create={MemberZDconfigCreate} 
                        edit={MemberZDconfigEdit} show={MemberZDconfigShow} />,
                    <Resource options={{ group: '会员', label: '年费记录', icon: <PaidIcon /> }}
                        name="Admin/CMSPartnerServiceChart" list={PartnerServiceChartList}
                        create={PartnerServiceChartCreate}
                        edit={PartnerServiceChartEdit} show={PartnerServiceChartShow} />,


                    <Resource options={{ group: '市场', label: '市场保护', icon: <ShieldIcon /> }}
                        name="Admin/CMSMarketPtrotection" list={MarketPtrotectionList} create={MarketPtrotectionCreate} edit={MarketPtrotectionEdit} show={MarketPtrotectionShow} />,
                    // <Resource options={{ group: '市场', label: '省份', icon: <FormatListBulletedIcon /> }}
                    //     name="Admin/CMSHospitalSheng" list={HospitalShengList} create={HospitalShengCreate} edit={HospitalShengEdit} show={HospitalShengShow} />,
                    // <Resource options={{ group: '市场', label: '城市', icon: <FormatListBulletedIcon /> }}
                    //     name="Admin/CMSHospitalCity" list={HospitalCityList} create={HospitalCityCreate} edit={HospitalCityEdit} show={HospitalCityShow} />

                    <Resource options={{ group: '产品', label: '列表(聚合)', icon: <AppsIcon /> }}
                        name="Admin/CMSProduct" list={ProductList} create={ProductCreate} edit={ProductEdit} />,
                    <Resource options={{ group: '产品', label: '分类', icon: <CategoryIcon /> }}
                        name="Admin/CMSProductCategory" list={ProductCategoryList} create={ProductCategoryCreate} edit={ProductCategoryEdit} />,
                    <Resource options={{ group: '产品', label: '排序', icon: <SortIcon /> }}
                        name="SortsDashboard" />,
                    <Resource options={{ group: '产品', label: '厂家', icon: <FactoryIcon /> }}
                        name="Admin/CMSProductCompany" list={ProductCompanyList} create={ProductCompanyCreate} edit={ProductCompanyEdit} show={ProductCompanyShow} />,
                    <Resource options={{ group: '产品', label: '产地', icon: <PlaceIcon /> }}
                        name="Admin/CMSProductCountry" list={ProductCountryList} create={ProductCountryCreate} edit={ProductCountryEdit} show={ProductCountryShow} />,

                    <Resource options={{ group: '供应', label: '供应', icon: <LocalShippingIcon /> }}
                        name="Admin/CMSSupplier" list={SupplierList} create={SupplierCreate} edit={SupplierEdit} show={SupplierShow} />,

                ] : [];

                return [

                    [...adminList],

                    <CustomRoutes>
                        <Route path="/ChangePwd" element={<ChangePwd />} />
                    </CustomRoutes>,
                    <CustomRoutes>
                        <Route path="/SortsDashboard" element={<SortsDashboard />} />
                    </CustomRoutes>,
                    // <CustomRoutes noLayout>
                    //     <Route path="/ShareOrder/:Sign" element={<ShareOrder />} />
                    // </CustomRoutes>,
                    // <CustomRoutes noLayout>
                    //     <Route path="/ShareJS/:Sign" element={<ShareJS />} />
                    // </CustomRoutes>,
                ]
            }}
        </Admin>
    );
};

export default App;